import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import LandingPage from "@/pages/LandingPage";
import SignUp from "@/pages/SignUp";
import Onboarding from "@/pages/Onboarding";
import OnboardingResults from "@/pages/OnboardingResults";
import AiVisibilityOffer from "@/pages/AiVisibilityOffer";
import ReviewSystemOffer from "@/pages/ReviewSystemOffer";
import Dashboard from "@/pages/Dashboard";
import MondayBrief from "@/pages/MondayBrief";
import BusinessHealth from "@/pages/BusinessHealth";
import Settings from "@/pages/Settings";
import SampleBrief from "@/pages/SampleBrief";
import AdminRequests from "@/pages/AdminRequests";
import AdminBriefs from "@/pages/AdminBriefs";
import AdminBriefDetail from "@/pages/AdminBriefDetail";
import AdminBusinesses from "@/pages/AdminBusinesses";
import AdminBusinessDetail from "@/pages/AdminBusinessDetail";
import BriefAction from "@/pages/BriefAction";
import Preferences from "@/pages/Preferences";
import ActionConfirm from "@/pages/ActionConfirm";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminCustomers from "@/pages/AdminCustomers";
import TermsOfService from "@/pages/TermsOfService";

function App() {
  return (
    <div className="App min-h-screen" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/onboarding/results/:businessId" element={<OnboardingResults />} />
          <Route path="/offers/ai-visibility" element={<AiVisibilityOffer />} />
          <Route path="/offers/ai-visibility/:businessId" element={<AiVisibilityOffer />} />
          <Route path="/offers/reviews" element={<ReviewSystemOffer />} />
          <Route path="/offers/reviews/:businessId" element={<ReviewSystemOffer />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/brief" element={<MondayBrief />} />
          <Route path="/sample-brief" element={<SampleBrief />} />
          <Route path="/health" element={<BusinessHealth />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admin/requests" element={<AdminRequests />} />
          <Route path="/admin/briefs" element={<AdminBriefs />} />
          <Route path="/admin/briefs/:id" element={<AdminBriefDetail />} />
          <Route path="/admin/businesses" element={<AdminBusinesses />} />
          <Route path="/admin/businesses/:id" element={<AdminBusinessDetail />} />
          <Route path="/brief-action" element={<BriefAction />} />
          <Route path="/preferences" element={<Preferences />} />
          <Route path="/actions/confirm" element={<ActionConfirm />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
